import React, {useEffect, useState} from "react";
import OpsInput from "../../ops-library/ops-input";
import OpsText from "../../ops-library/ops-text";
import OpsBtn from "../../ops-library/ops-btn";
import {Modal} from "react-bootstrap";
import opsToast from "../../ops-library/ops-toast";
import axios from "axios";
import {BiShow} from "react-icons/bi";
import {hasRoleAccess} from "../../functions/hasRoleAccess";
import {LoadingSpinner} from "../LoadingSpinner";
import {opsConfirmDialog} from "../../ops-library/ops-confirm-dialog";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import {FiFilter} from "react-icons/fi";
import OpsToast from "../../ops-library/ops-toast";
import formatDate from "../../functions/formatDate";
import {FaPlus} from "react-icons/fa";
import OpsTable from "../../ops-library/ops-table";
import OpsIconStatus from "../../ops-library/ops-icon-status";
import OpsOrderStatus from "../../ops-library/OpsOrderStatus";
import validator from "validator";
import {isValidSlovakPhoneNumber} from "../../functions/isValidSlovakPhoneNumber";
import {FaTrashCan} from "react-icons/fa6";

const AdminOrders = ({sectionId, theme, user}) => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const [orders, setOrders] = useState(null)
    const [showDeleted, setShowDeleted] = useState(false)
    const [modalOrderShown, setModalOrderShown] = useState(false);
    const [loading, setLoading] = useState(true)

    const [modalData, setModalData] = useState(null);

    useEffect(() => {
        getOrders();
    }, []);

    // API functions - get/patch/restore
    // ------------------------------------------------------------------------------
    function getOrders(showDeleted = false) {
        setLoading(true)
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/orders?includeDeleted=${showDeleted}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        axios(configuration)
            .then((result) => {
                setOrders(result.data.content)
                setLoading(false)
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }

    function patchOrderStatus(id, data) {
        setLoading(true)
        opsToast('Prebieha aktualizácia stavu zvolenej objednávky...', "default", "colored", true, "top-center", 5000)
        const configuration = {
            method: "patch",
            url: `${process.env.REACT_APP_API_BASE_URL}/orders/${id}/status?includeDeleted=${showDeleted}`,
            data: data,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((result) => {
                if (result.data.content !== undefined) {
                    setOrders(result.data.content)
                    OpsToast(result.data.message, "success", "light", false, "top-center", 5000)
                }
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    }

    // MODALS
    // ------------------------------------------------------------------------------
    function handleOpenModalOrder(data) {
        if (data) {
            setModalOrderShown(true);
            setModalData(data)
        } else {
            setModalOrderShown(true);
            setModalData(null);
        }
    }

    function handleModalsClose() {
        setModalOrderShown(false)
        setModalData(null)
    }

    const ModalOrder = ({show = false, onHide}) => {

        const [processed, setProcessed] = useState(false)
        const [editable, setEditable] = useState(modalData !== null ? false : true)
        const [customerName, setCustomerName] = useState(modalData?.customer.name ?? "");
        const [customerEmail, setCustomerEmail] = useState(modalData?.customer.email ?? "");
        const [customerPhone, setCustomerPhone] = useState(modalData?.customer.phone ?? "");
        const [customerAddressStreet, setCustomerAddressStreet] = useState(modalData?.customer.addressStreet ?? "");
        const [customerAddressNr, setCustomerAddressNr] = useState(modalData?.customer.addressNr ?? "");
        const [customerAddressCity, setCustomerAddressCity] = useState(modalData?.customer.addressCity ?? "");
        const [customerAddressPostalCode, setCustomerAddressPostalCode] = useState(modalData?.customer.addressPostalCode ?? "");
        const [ordersProducts, setOrdersProducts] = useState(modalData?.products ?? []);
        const [shipMethod, setShipMethod] = useState(modalData?.shipping.method ?? "");
        // const [paymentMethod, setPaymentMethod] = useState(modalData?.payment.method ?? "");
        // const [paymentStatus, setPaymentStatus] = useState(modalData?.payment.status ?? "");
        // const [paymentPaid, setPaymentPaid] = useState(modalData?.payment.paid ?? "");
        // const [shippedAt, setShippedAt] = useState(modalData?.shipping.shippedAt ?? "");
        // const [trackingNumber, setTrackingNumber] = useState(modalData?.shipping.trackingNumber ?? "");
        // const [estimatedDelivery, setEstimatedDelivery] = useState(modalData?.shipping.estimatedDelivery ?? "");
        const [notes, setNotes] = useState(modalData?.notes ?? "");
        const [products, setProducts] = useState()
        const [showProducts, setShowProducts] = useState(false)

        useEffect(() => {
            getAllProducts();
        }, []);

        // API functions - patch/post/delete
        // ------------------------------------------------------------------------------
        function patchOrder(id) {
            setProcessed(true)
            const orderData = {
                customer: {
                    name: customerName,
                    email: customerEmail,
                    phone: customerPhone,
                    addressStreet: customerAddressStreet,
                    addressNr: customerAddressNr,
                    addressCity: customerAddressCity,
                    addressPostalCode: customerAddressPostalCode
                },
                products: ordersProducts,
                totalPrice: calculateTotalPrice(ordersProducts),
                shipping: {
                    method: shipMethod,
                },
                notes: notes,
                personalDataConsent: true,
            };

            const configuration = {
                method: "patch",
                url: `${process.env.REACT_APP_API_BASE_URL}/orders/${id}?includeDeleted=${showDeleted}`,
                data: orderData,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            axios(configuration)
                .then((result) => {
                    if (result.data.content !== undefined) {
                        setOrders(result.data.content)
                        OpsToast(result.data.message, "success")
                        handleModalsClose()
                    }
                })
                .catch((error) => {
                    opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        function postOrder() {
            setProcessed(true)
            const orderData = {
                customer: {
                    name: customerName,
                    email: customerEmail,
                    phone: customerPhone,
                    addressStreet: customerAddressStreet,
                    addressNr: customerAddressNr,
                    addressCity: customerAddressCity,
                    addressPostalCode: customerAddressPostalCode
                },
                products: ordersProducts,
                totalPrice: calculateTotalPrice(ordersProducts),
                shipping: {
                    method: shipMethod,
                },
                notes: notes,
                personalDataConsent: true,
                createdBy: 'system'
            };

            const configuration = {
                method: 'post',
                url: `${process.env.REACT_APP_API_BASE_URL}/orders?includeDeleted=${showDeleted}`,
                data: orderData,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            axios(configuration)
                .then((result) => {
                    opsToast(result?.data?.message, "success");
                    setOrders(result.data.content)
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        function getAllProducts() {
            const configuration = {
                method: "get",
                url: `${process.env.REACT_APP_API_BASE_URL}/products?includeDeleted=${false}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            axios(configuration)
                .then((result) => {
                    setProducts(result.data.content)
                })
                .catch((error) => {
                    opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                });
        }

        // POMOCNE FUNKCIE
        // list zvolenych produktov objednavky (pridanie/zmazanie)
        const addProductToList = (productId, name, price) => {
            setOrdersProducts(prevProducts => {
                const existingProduct = prevProducts.find(product => product.productId === productId);

                if (existingProduct) {
                    return prevProducts.map(product =>
                        product.productId === productId
                            ? {...product, quantity: product.quantity + 1}
                            : product
                    );
                } else {
                    return [...prevProducts, {productId, name, quantity: 1, price}];
                }
            });
        };
        const removeProductFromList = (index) => {
            setOrdersProducts(ordersProducts.filter((_, i) => i !== index));
        };

        // vypocitanie celkovej ceny podla produktov v objednavke
        const calculateTotalPrice = (products) => {
            return products.reduce((total, product) => total + product.quantity * product.price, 0);
        };

        // validacia dat pri vytvoreni objednavky
        function validateOrderData() {
            if (!customerName || customerName.trim().length < 3) {
                opsToast("Zadajte platné meno (min. 3 znaky)", "error");
                setProcessed(false);
                return false;
            }
            if (!validator.isEmail(customerEmail)) {
                opsToast("Zadajte platný e-mail", "error");
                setProcessed(false);
                return false;
            }
            if (!isValidSlovakPhoneNumber(customerPhone)) {
                opsToast("Zadajte platné slovenské telefónne číslo", "error");
                setProcessed(false);
                return false;
            }
            if (!customerAddressStreet || !customerAddressNr || !customerAddressCity || !customerAddressPostalCode) {
                opsToast("Vyplňte všetky dodacie údaje", "error");
                setProcessed(false);
                return false;
            }
            if (!validator.isNumeric(customerAddressPostalCode) || customerAddressPostalCode.length !== 5) {
                opsToast("Zadajte platné PSČ (5 čísel)", "error");
                setProcessed(false);
                return false;
            }
            if (ordersProducts.length === 0) {
                opsToast("Žiaden produkt nie je zvolený!", "error");
                setProcessed(false);
                return false;
            }
            if (shipMethod === null || shipMethod === "") {
                opsToast("Žiaden spôsob doručenia nie je zvolený!", "error");
                setProcessed(false);
                return false;
            }

            return true;
        }


        return (
            <Modal show={show} onHide={onHide} data-theme={theme} dialogClassName="custom-modal-container">
                <Modal.Header closeButton closeVariant="white"
                              className="modal-background-color">
                    <div className="fa-flex-row justify-content-between w-100 h-100">
                        <OpsText type="title" weight={700} color="primary-3" alignment="left"
                                 content={`${customerName}`}/>
                        {modalData && editable && <OpsBtn
                            icon={<FaTrashCan color="color-1" className="ops-icon-sm m-1"/>}
                            variant="icon me-2"
                            padding={false}
                            action={() => {
                                const actualOrder = modalData;
                                handleModalsClose()
                                opsConfirmDialog(
                                    "Zrušenie objednávky",
                                    `Naozaj si prajete zrušiť objednávku?`,
                                    theme,
                                    () => patchOrderStatus(modalData?._id, {status: "CANCELLED"}),
                                    () => handleOpenModalOrder(actualOrder)
                                )
                            }}
                        />}
                    </div>
                </Modal.Header>

                <Modal.Body className="modal-background-color fa-flex-col align-items-center">
                    {!processed ?
                        <div className="custom-modal-content justify-content-between">
                            {/*HLAVICKA*/}
                            <div className="desktop-row-phone-col justify-content-between w-100 mb-2">
                                {modalData && <div className="fa-flex-col">
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`Autor: ${modalData.createdBy === 'customer' ? 'zákazník' : 'admin'}`}/>
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`ID objednávky: ${modalData.orderId}`}/>
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`Upravené: ${formatDate(modalData.updatedAt, true)}`}/>
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`Vytvorené: ${formatDate(modalData.createdAt, true)}`}/>
                                </div>}
                                {modalData?.status === 'PROCESSING' && hasRoleAccess(sectionId, user.role) &&
                                    <div className="fa-flex-col align-items-end gap-1">
                                        <OpsText type="label" alignment="right" color="color-1"
                                                 content={editable ? 'Zrušiť editáciu' : 'Editovať'}/>
                                        <OpsInput customType="switch" checked={editable}
                                                  onChange={() => setEditable(!editable)}
                                        />
                                    </div>
                                }
                            </div>

                            {/*FORMULAR*/}
                            <div className="fa-flex-col fa-w-100 gap-1 justify-content-between">
                                {/*Meno a priezvisko*/}
                                <OpsInput
                                    size="100"
                                    type="text"
                                    id="name"
                                    disabled={!editable}
                                    value={customerName}
                                    label="OSOBNÉ ÚDAJE"
                                    labelWeight={700}
                                    className={!editable ? "color-2" : ""}
                                    placeholder="Meno a priezvisko"
                                    onChange={(e) => {
                                        setCustomerName(e.target.value)
                                    }}
                                />
                                {/*Emailova adresa*/}
                                <OpsInput
                                    size="100"
                                    type="email"
                                    id="email"
                                    disabled={!editable}
                                    value={customerEmail}
                                    className={!editable ? "color-2" : ""}
                                    placeholder="Emailová adresa (napr. tom@mail.com)"
                                    onChange={(e) => {
                                        setCustomerEmail(e.target.value)
                                    }}
                                />
                                {/*Tel. cislo*/}
                                <OpsInput
                                    size="100"
                                    type="tel"
                                    id="phone"
                                    disabled={!editable}
                                    value={customerPhone}
                                    className={!editable ? "color-2" : ""}
                                    placeholder="Telefónne číslo (0915 123 654)"
                                    onChange={(e) => {
                                        setCustomerPhone(e.target.value)
                                    }}
                                />
                                <div className="desktop-row-phone-col align-items-end gap-1 fa-w-100">
                                    {/*Ulica*/}
                                    <OpsInput
                                        size="md"
                                        type="text"
                                        id="street"
                                        disabled={!editable}
                                        className={!editable ? "color-2" : ""}
                                        componentClassName="desktop-75-phone-100"
                                        value={customerAddressStreet}
                                        label="DODACIE ÚDAJE"
                                        labelWeight={700}
                                        placeholder="Ulica"
                                        onChange={(e) => {
                                            setCustomerAddressStreet(e.target.value)
                                        }}
                                    />
                                    {/*Cislo domu*/}
                                    <OpsInput
                                        size="sm"
                                        type="text"
                                        disabled={!editable}
                                        className={!editable ? "color-2" : ""}
                                        componentClassName="desktop-25-phone-100"
                                        value={customerAddressNr}
                                        labelWeight={700}
                                        placeholder="Číslo"
                                        onChange={(e) => {
                                            setCustomerAddressNr(e.target.value)
                                        }}
                                    />
                                </div>
                                {/*Mesto*/}
                                <OpsInput
                                    size="100"
                                    type="text"
                                    id="city"
                                    disabled={!editable}
                                    value={customerAddressCity}
                                    className={!editable ? "color-2" : ""}
                                    placeholder="Mesto"
                                    onChange={(e) => {
                                        setCustomerAddressCity(e.target.value)
                                    }}
                                />
                                {/*PSC*/}
                                <OpsInput
                                    size="100"
                                    type="text"
                                    id="zip"
                                    disabled={!editable}
                                    value={customerAddressPostalCode}
                                    className={!editable ? "color-2" : ""}
                                    placeholder="PSČ (08256) - bez medzier"
                                    onChange={(e) => {
                                        setCustomerAddressPostalCode(e.target.value)
                                    }}
                                />
                                {/*Poznamky*/}
                                <OpsInput customType="textarea" className={!editable ? "color-2" : ""} value={notes}
                                          maxLength={350} label="POZNÁMKY" labelWeight={700} disabled={!editable}
                                          placeholder="Zadajte doplňujúce informácie k objednávke..."
                                          onChange={(e) => setNotes(e.target.value)}/>
                                {/*Doprava*/}
                                <OpsInput
                                    id="shipMethod" customType="select"
                                    label="DOPRAVA" labelWeight={700}
                                    disabled={!editable}
                                    isSearchable
                                    className="fa-w-100"
                                    options={[
                                        {value: "standard", label: "Doprava poštou (dobierka)"},
                                        {value: "pickup", label: "Osobný odber"}
                                    ]}
                                    value={shipMethod ? {
                                        value: shipMethod,
                                        label: shipMethod === "standard" ? "Doprava poštou (dobierka)" : "Osobný odber"
                                    } : null}
                                    defaultValue={shipMethod ? {
                                        value: shipMethod,
                                        label: shipMethod === "standard" ? "Doprava poštou (dobierka)" : "Osobný odber"
                                    } : null}
                                    onChange={(e) => setShipMethod(e ? e.value : "")}
                                />
                            </div>

                            {/*PRODUKTY + PRIDANIE PRODUKTU*/}
                            <div className="fa-flex-col fa-w-100 gap-1 justify-content-between">
                                <OpsText type="normal2 px-1 mt-3 mb-2" weight={700} color="color-1"
                                         alignment="justify"
                                         content="PRODUKTY (musia zahŕňať aj spôsobo doručenia)"/>
                                <div className="fa-flex-col gap-1 px-2">
                                    {ordersProducts.map((product, idx) => (
                                            <div className="fa-flex-row fa-w-100 align-items-center gap-2">
                                                <div className="fa-flex-row fa-w-80">
                                                    <OpsText type="normal" color="color-1"
                                                             alignment="left" className="fa-w-70"
                                                             content={product.name}/>
                                                    <OpsText type="normal" color="color-1"
                                                             alignment="left" className="fa-w-15"
                                                             content={`${product.quantity}x`}/>
                                                    <OpsText type="normal" color="color-1"
                                                             alignment="right" className="fa-w-15"
                                                             content={`${product.price} €`}/>
                                                </div>
                                                {editable &&
                                                    <div className="fa-flex-row fa-w-20 justify-content-end">
                                                        <FaTrashCan color="var(--color-p-300)"
                                                                    className="ops-icon-sm m-1 pointer-cursor"
                                                                    onClick={() => removeProductFromList(idx)}/>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    )}
                                </div>
                                {showProducts ?
                                    <div className="fa-flex-col gap-2">
                                        <div className="fa-flex-row justify-content-between">
                                            <OpsText type="normal2 px-1 mt-3 mb-2" weight={700} color="color-1"
                                                     alignment="justify"
                                                     content="DOSTUPNÉ PRODUKTY"/>
                                            <OpsBtn
                                                btnText
                                                text="Skryť ponuku"
                                                textStyle="text-center mt-3"
                                                action={() => setShowProducts(false)}
                                            />
                                        </div>
                                        <div className="fa-flex-col gap-1 px-1 py-2 border border-2 border-white">
                                            {products !== undefined && products.map((product) => (
                                                    <div className="fa-flex-row fa-w-100 align-items-center gap-2">
                                                        <div className="fa-flex-row fa-w-80">
                                                            <OpsText type="normal" color="color-1"
                                                                     alignment="left" className="fa-w-70"
                                                                     content={product.name}/>
                                                            <OpsText type="normal" color="color-1"
                                                                     alignment="left"
                                                                     className="fa-w-15 fst-italic phone-not-shown"
                                                                     content={product.shippingSupplement === true && '(doprava)'}/>
                                                            <OpsText type="normal" color="color-1"
                                                                     alignment="right" className="fa-w-15"
                                                                     content={`${product.price} €`}/>
                                                        </div>
                                                        <div className="fa-flex-row fa-w-20 justify-content-end">
                                                            <FaPlus color="var(--color-p-300)"
                                                                    className="ops-icon-sm m-1 pointer-cursor"
                                                                    onClick={() => addProductToList(product._id, product.name, product.price)}/>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                    :
                                    editable && <OpsBtn
                                        btnText
                                        text="Pridať produkty"
                                        textStyle="text-center mt-3"
                                        action={() => setShowProducts(true)}
                                    />
                                }
                            </div>

                            {/*ZAHODIT + ULOZIT*/}
                            {editable &&
                                <div className="desktop-row-phone-col gap-2 mt-5 w-100 justify-content-center">
                                    <OpsBtn
                                        text="Zahodiť"
                                        variant="secondary"
                                        size="md mt-2"
                                        action={() => handleModalsClose()}
                                    />
                                    {/*TODO: dokonci*/}
                                    <OpsBtn
                                        text="Uložiť"
                                        variant="primary"
                                        size="md mt-2"
                                        action={() => validateOrderData() && (modalData !== null
                                            ? patchOrder(modalData?._id)
                                            : postOrder())
                                        }
                                    />
                                </div>
                            }

                        </div>
                        :
                        <div className="custom-modal-content">
                            <LoadingSpinner/>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        )
    }


    return (
        <div className="adm-section gap-3" id="admin-concerts">
            <ModalOrder show={modalOrderShown} onHide={() => handleModalsClose()}/>

            <OpsText type="title mb-3 fa-w-100" weight={700} alignment="right"
                     content="OBJEDNÁVKY"/>

            {/* SPRAVA OBJEDNAVOK */}
            <div className="adm-container fa-flex-col">
                <div className="fa-flex-row fa-w-100 justify-content-between px-1 py-3 ">
                    <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                             content="Správa objednávok"/>
                    <div className="fa-flex-row">
                        {/*VYTVORIT OBJEDNAVKU<*/}
                        {hasRoleAccess(sectionId, user.role) && <OpsBtn
                            id="tbl-create"
                            tooltipText="Vytvoriť objednávku"
                            icon={<FaPlus color="var(--color-p-300)"
                                          className="ops-icon-sm m-1 mx-3"/>}
                            variant="icon mx-1"
                            backgroundColor="bg-3 border border-1"
                            padding={false}
                            action={() => {
                                handleOpenModalOrder()
                            }}
                        />}
                        {/*ZOBRAZIT AJ ZRUSENE/DORUCENE*/}
                        <OpsBtn
                            id="tbl-filter-deleted"
                            tooltipText="Zobraziť všetky objednávky"
                            icon={<FiFilter color={!showDeleted ? "var(--color-p-300)" : "var(--color-1)"}
                                            className="ops-icon-sm m-1"/>}
                            variant="icon mx-1"
                            backgroundColor={`${!showDeleted ? 'bg-3' : 'bg-primary-3'} border border-1`}
                            padding={false}
                            action={() => {
                                setShowDeleted(!showDeleted)
                                getOrders(!showDeleted)
                            }}
                        />
                    </div>
                </div>
                {/*HLAVNA TABUĽKA*/}
                <OpsTable
                    id="concerts"
                    name=""
                    theme={theme}
                    classname=""
                    columns={[
                        {
                            name: "Status",
                            selector: row => row.status,
                            sortable: true,
                            width: '10%',
                            cell: (row) =>
                                <OpsOrderStatus status={row.status}/>
                        },
                        {
                            name: "Dátum vytvorenia",
                            selector: row => new Date(row.createdAt).getTime(),
                            sortable: true,
                            width: '15%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.status === 'CANCELLED'}
                                    color={row.status === 'CANCELLED' && 'color-g-2'}
                                    content={`${new Date(row.createdAt).toLocaleDateString('sk-SK', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    }).replace(/\s/g, '')} - ${new Date(row.createdAt).toLocaleTimeString('sk-SK', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false
                                    })}`}
                                />
                            )
                        },
                        {
                            name: "ID objednávky",
                            selector: row => row.orderId,
                            sortable: false,
                            width: '10%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis className="fst-italic"
                                    lineThrough={row.status === 'CANCELLED'}
                                    color={row.status === 'CANCELLED' && 'color-g-2'}
                                    content={row.orderId}
                                />
                            )
                        },
                        {
                            name: "Objednávateľ",
                            selector: row => row.customer,
                            sortable: false,
                            width: '20%',
                            cell: (row) => (
                                <OpsText
                                    type="label8"
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.status === 'CANCELLED'}
                                    color={row.status === 'CANCELLED' && 'color-g-2'}
                                    content={`${row.customer.name} (${row.customer.addressCity})`}
                                />
                            )
                        },
                        {
                            name: "Tel. číslo",
                            selector: row => row.customer,
                            sortable: false,
                            width: '10%',
                            cell: (row) => (
                                <OpsText
                                    type="label8"
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.status === 'CANCELLED'}
                                    color={row.status === 'CANCELLED' && 'color-g-2'}
                                    content={`${row.customer.phone}`}
                                />
                            )
                        },
                        {
                            name: "Cena",
                            selector: row => row.totalPrice,
                            sortable: false,
                            width: '10%',
                            center: true,
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.status === 'CANCELLED'}
                                    color={row.status === 'CANCELLED' && 'color-g-2'}
                                    content={`${row.totalPrice} €`}
                                />
                            )
                        },
                        {
                            name: "",
                            selector: row => row.published,
                            sortable: false,
                            width: '5%',
                            center: true,
                            cell: (row) =>
                                <OpsIconStatus status={row.shipping.method}/>
                        },
                        {
                            name: "",
                            selector: row => row.createdBy,
                            sortable: false,
                            width: '5%',
                            center: true,
                            cell: (row) =>
                                <OpsIconStatus status={row.createdBy}/>
                        },
                        {
                            name: "Poznámky",
                            selector: row => row.notes,
                            sortable: false,
                            width: '10%',
                            cell: (row) => (
                                <OpsText
                                    type="label8"
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.status === 'CANCELLED'}
                                    color={row.status === 'CANCELLED' && 'color-g-2'}
                                    content={`${row.notes}`}
                                />
                            )
                        },
                        {
                            name: "",
                            sortable: false,
                            selector: null,
                            width: '12%',
                            right: true,
                            cell: (row) => [
                                hasRoleAccess(sectionId, user.role) && row.status === 'PENDING' ? <OpsBtn
                                        key={0}
                                        variant="primary"
                                        size="sm-text"
                                        textSize="md"
                                        id="process-order-btn"
                                        fontWeight={700}
                                        text="Prijať"
                                        backgroundColor={"bg-primary-4"}
                                        padding={false}
                                        action={() => patchOrderStatus(row._id, {status: "PROCESSING"})}
                                    /> :
                                    hasRoleAccess(sectionId, user.role) && row.status === 'PROCESSING' ? <OpsBtn
                                            key={0}
                                            variant="primary"
                                            size="sm-text"
                                            textSize="md"
                                            id="ship-order-btn"
                                            fontWeight={700}
                                            text="Odoslať"
                                            backgroundColor="bg-success"
                                            padding={false}
                                            action={() => opsConfirmDialog(
                                                "Odoslanie objednávky",
                                                `Naozaj si prajete odoslať objednávku? Objednávateľ dostane email, že objednávka bola odoslaná a nebude možná jej žiadna ďalšia editácia (vrátane zrušenia)!`,
                                                theme,
                                                () => patchOrderStatus(row._id, {status: "SHIPPED"}),
                                                () => null
                                            )}
                                        /> :
                                        hasRoleAccess(sectionId, user.role) && row.status === 'SHIPPED' ? <OpsBtn
                                            key={0}
                                            variant="primary"
                                            textSize="md"
                                            size="sm-text"
                                            id="delivered-order-btn"
                                            fontWeight={700}
                                            text="Uzavrieť"
                                            backgroundColor={"bg-primary-3"}
                                            padding={false}
                                            action={() => patchOrderStatus(row._id, {status: "DELIVERED"})}
                                        /> : null,
                                <OpsBtn
                                    key={1}
                                    icon={<BiShow className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor={"bg-primary-3"}
                                    padding={false}
                                    action={() => {
                                        handleOpenModalOrder(row)
                                    }}
                                />
                            ]
                        }
                    ]}
                    data={loading === false ? orders : []}
                />
            </div>
        </div>
    )
}

export default AdminOrders;